import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ProhibitIcon as Prohibit } from "@phosphor-icons/react";
import { toast } from "sonner";
import { formatApiError, formatDate } from "@/lib/utils-app";

export const BlockedUsersCard = () => {
  const [rows, setRows] = useState(null);

  const load = async () => {
    try {
      const r = await api.get("/me/blocked-users", { silent: true });
      setRows(r.data?.blocked || []);
    } catch {
      setRows([]);
    }
  };
  useEffect(() => { load(); }, []);

  const unblock = async (userId) => {
    try {
      await api.delete(`/users/${userId}/block`);
      toast.success("User unblocked.");
      load();
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  return (
    <div className="bg-white border border-[#EAEAEA] rounded-xl p-5 shadow-luxury-light" data-testid="blocked-users-card">
      <div className="flex items-center gap-2 mb-1">
        <Prohibit size={18} weight="duotone" className="text-crimson" />
        <h3 className="font-spectral text-lg tracking-tight">Blocked users</h3>
      </div>
      <p className="text-[13px] text-[#6B6B6B] mb-4 leading-relaxed">
        Blocked users can't message you, and you won't see their posts in The Dog's Voice.
      </p>
      {rows === null ? (
        <div className="text-sm text-[#6B6B6B]">Loading…</div>
      ) : rows.length === 0 ? (
        <div className="text-sm text-[#6B6B6B]" data-testid="blocked-users-empty">
          You haven't blocked anyone.
        </div>
      ) : (
        <ul className="divide-y divide-[#F0F0F0]">
          {rows.map((r) => (
            <li key={r.user_id} className="flex items-center justify-between py-2.5" data-testid={`blocked-user-${r.user_id}`}>
              <div className="min-w-0">
                <div className="text-sm font-medium truncate">{r.name}</div>
                <div className="text-xs text-[#6B6B6B]">Blocked {formatDate(r.blocked_at)}</div>
              </div>
              <Button
                variant="outline"
                size="sm"
                className="rounded-full"
                onClick={() => unblock(r.user_id)}
                data-testid={`unblock-user-${r.user_id}-btn`}
              >
                Unblock
              </Button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default BlockedUsersCard;
